var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#191918",
  d: "M18.04 16.563c-1.19-2.057-3.023-3.532-5.163-4.232a5.625 5.625 0 1 0-5.754 0c-2.14.699-3.974 2.174-5.164 4.232a.625.625 0 1 0 1.082.625c1.472-2.544 4.074-4.063 6.959-4.063s5.487 1.519 6.959 4.063a.627.627 0 0 0 1.047.079.625.625 0 0 0 .035-.704M5.626 7.5a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0"
})));
export { SvgContactIcon as ReactComponent };
export default __webpack_public_path__ + "cf76949684d902cfb138e3a29a28e1ac.svg";